import { CssBaseline, ThemeProvider } from '@mui/material';
import i18next from 'i18next';
import './App.css';
import { AppRouter } from './router/AppRouter';
import { lightTheme } from './theme/light-theme';
import global_es from './translation/es/global.json';
import global_en from './translation/en/global.json';
import { I18nextProvider } from 'react-i18next';

i18next.init({
  interpolation: { escapeValue: false },
  lng: "es",
  resources: {
    es: {
      global: global_es,
    },
    en: {
      global: global_en,
    }
  }
})

function App() {
  return (
    <ThemeProvider theme={lightTheme}>
      <I18nextProvider i18n={i18next}>
        <CssBaseline />
        <AppRouter />
      </I18nextProvider>
    </ThemeProvider>
  );
}

export default App;
